/**
 * @generated SignedSource<<281306ee4f7978d5c2d4089e117d3bcb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeletePersonDismissedProjectNotificationMutationInput = {
  projectId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type DeletePersonDismissedProjectNotificationMutation$variables = {
  input: DeletePersonDismissedProjectNotificationMutationInput;
};
export type DeletePersonDismissedProjectNotificationMutation$data = {
  readonly deletePersonDismissedProjectNotificationMutation: {
    readonly viewer: {
      readonly personDismissedProjectNotificationIds: ReadonlyArray<string | null> | null;
    } | null;
  } | null;
};
export type DeletePersonDismissedProjectNotificationMutation = {
  variables: DeletePersonDismissedProjectNotificationMutation$variables;
  response: DeletePersonDismissedProjectNotificationMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "personDismissedProjectNotificationIds",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeletePersonDismissedProjectNotificationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeletePersonDismissedProjectNotificationMutationPayload",
        "kind": "LinkedField",
        "name": "deletePersonDismissedProjectNotificationMutation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeletePersonDismissedProjectNotificationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeletePersonDismissedProjectNotificationMutationPayload",
        "kind": "LinkedField",
        "name": "deletePersonDismissedProjectNotificationMutation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "abf7c2e0bce921400b5d55322151b030",
    "id": null,
    "metadata": {},
    "name": "DeletePersonDismissedProjectNotificationMutation",
    "operationKind": "mutation",
    "text": "mutation DeletePersonDismissedProjectNotificationMutation(\n  $input: DeletePersonDismissedProjectNotificationMutationInput!\n) {\n  deletePersonDismissedProjectNotificationMutation(input: $input) {\n    viewer {\n      personDismissedProjectNotificationIds\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f113bd85271a54dcd54f463bd6b280b5";

export default node;
